import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Button, Dropdown } from 'antd';
import { LogoutOutlined, UserOutlined, BellOutlined, SettingOutlined } from '@ant-design/icons';
import { HiMenuAlt3, HiChevronDown } from 'react-icons/hi';
import { useAuth } from '../context/AuthContext';

const Navbar = ({ toggleSidebar }) => {
    const { pathname } = useLocation();

    const navigate = useNavigate();
    const { user, logout } = useAuth();

    const handleLogout = () => {
        logout();
        navigate('/');
    }

    const menuItems = [
        {
            key: 'account',
            icon: <UserOutlined />,
            label: (
                <div className="flex flex-col">
                    <span className="font-medium">{user && user.name}</span>
                    <span className="text-xs text-gray-500">{user && user.role}</span>
                </div>
            ),
        },
        {
            type: 'divider',
        },
        // {
        //     key: 'settings',
        //     icon: <SettingOutlined />,
        //     label: 'Settings',
        // },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: <button onClick={handleLogout} className="text-red-600 hover:text-red-700">Sign Out</button>,
        },
    ];

    return (
        <nav className="bg-white/80 backdrop-blur-md border-b border-gray-200/50 shadow-sm sticky top-0 z-50">
            <div className="flex items-center justify-between px-4 py-3">
                {/* Left side - Logo and mobile menu */}
                <div className="flex items-center space-x-4">
                    {pathname !== "/monitoring" && (
                        <button
                            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                            onClick={toggleSidebar}
                        >
                            <HiMenuAlt3 className="w-6 h-6 text-gray-600" />
                        </button>
                    )}
                    {pathname === "/monitoring" && (
                        <div className="flex items-center space-x-3">
                            <div className="relative">
                                <img
                                    src="/assets/favicon/favicon-96x96.png"
                                    className="w-10 h-10"
                                    alt="NextSense Icon"
                                />
                                {/* <div className="absolute -top-1 -right-1 w-4 h-4 bg-success-500 rounded-full border-2 border-white animate-pulse"></div> */}
                            </div>
                            <div>
                                <h1 className="text-xl font-bold gradient-text">NextSense</h1>
                                <p className="text-xs text-gray-500">Marine Monitoring System</p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Right side - Actions and user menu */}
                <div className="flex items-center space-x-3">
                    {/* Notifications */}
                    {/* <Button
                        type="text"
                        shape="circle"
                        icon={<BellOutlined className="text-gray-600" />}
                        className="hover:bg-gray-100 transition-colors duration-200"
                    /> */}

                    {/* User Menu */}
                    <Dropdown
                        menu={{ items: menuItems }}
                        trigger={['click']}
                        placement="bottomRight"
                        overlayClassName="modern-dropdown"
                    >
                        <Button
                            type="text"
                            className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-all duration-200"
                        >
                            <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center">
                                <UserOutlined className="text-white text-sm" />
                            </div>
                            <div className="hidden sm:block text-left">
                                <p className="text-sm font-medium text-gray-900">{user && user.name}</p>
                                <p className="text-xs text-gray-500">{user && user.role}</p>
                            </div>
                            <HiChevronDown className="w-4 h-4 text-gray-400" />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        </nav>
    )
}

export default Navbar